<template>
  <div class="row billing-section">
    <div id="agreements-eft-table" class="col-md-12 materialized">
      <vue-good-table
        :columns="columns"
        :rows="eftAgreements"
        styleClass="table condensed table-hover"
        sortable=false>
        <template slot="table-row" slot-scope="props">
          <td class="text-center materialized" data-title=''>
            <el-checkbox role="button" :checked="true" @change="value => addEftAgreement(value, props.row.agreementId  )"
                         :value="selectedEftAgreements.indexOf(props.row.agreementId) > -1" indextab="2"></el-checkbox>
          </td>
          <td class="text-center" data-title='Member'><span class="data-item"><b>{{ props.row.memberName }}</b></span>
          </td>
          <td class="text-center" data-title='Agreement'>
            <span class="data-item">{{ props.row.agreementId}}</span>
            <br>
            <span class="data-item">{{ '(' + props.row.agreementType + ')' }}</span>
          </td>
          <td class="text-center" data-title='Auto-Billed'>
            <b>
              <template v-if="props.row.accountType === 'MC'">
                <i class="cc-sprite mc-cc-color"
                   :class="{'overdue-card' : props.row.cardExpirationDateValue.valueOf() < moment().valueOf()}"></i>
              </template>
              <template v-else-if="props.row.accountType === 'VISA'">
                <i class="cc-sprite visa-cc-color"
                   :class="{'overdue-card' : props.row.cardExpirationDateValue.valueOf() < moment().valueOf()}"></i>
              </template>
              <template v-else-if="props.row.accountType === 'AMX'">
                <i class="cc-sprite amx-cc-color"
                   :class="{'overdue-card' : props.row.cardExpirationDateValue.valueOf() < moment().valueOf()}"></i>
              </template>
              <template v-else-if="props.row.accountType === 'DIS'">
                <i class="cc-sprite dis-cc-color"
                   :class="{'overdue-card' : props.row.cardExpirationDateValue.valueOf() < moment().valueOf()}"></i>
              </template>
              <template v-else>
                <i class="fa fa-university fa-lg"></i>
              </template>
              <span class="data-item col-xs-12" :class="{'overdue-card' :
              !(props.row.accountType === 'SAV' || props.row.accountType === 'CHK')
              && props.row.cardExpirationDateValue.valueOf() < moment().valueOf()}">
                {{ props.row.autoBilled }}
              </span>
              <template v-if="props.row.cardExpirationDate">
                  <span class="data-item col-xs-12"
                        :class="{'overdue-card' : props.row.cardExpirationDateValue.valueOf() < moment().valueOf()}">(Exp. {{ props.row.cardExpirationDateText }})</span>
              </template>
            </b>
          </td>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'
  import { StringUtils } from 'my-account-common'
  import moment from 'moment'

  export default {
    name: 'AgreementsEFTTable',
    props: {
      agreementData: {
        type: Object,
        required: true
      },
      paymentInfo: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        selectedEftAgreements: [],
        moment: moment,
        columns: [
          {
            label: '',
            field: 'selected',
            tdClass: 'text-center',
            thClass: 'text-center'
          },
          {
            label: 'Member',
            field: 'memberName',
            tdClass: 'text-center',
            thClass: 'text-center'
          },
          {
            label: 'Agreement',
            field: 'agreementId',
            tdClass: 'text-center',
            thClass: 'text-center'
          },
          {
            label: 'Payment Method',
            field: 'autoBilled',
            tdClass: 'text-center',
            thClass: 'text-center'
          }]
      }
    },
    mounted () {
      this.selectedEftAgreements = this.eftAgreements.map((agreement) => agreement.agreementId)
      this.$emit('change', this.selectedEftAgreements)
    },
    methods: {
      addEftAgreement (value, workWith) {
        if (!value.target.checked) {
          this.selectedEftAgreements = this.selectedEftAgreements.filter(function (name) {
            return name !== workWith
          }).map(value => value)
        } else {
          this.selectedEftAgreements.push(workWith)
        }
        this.$emit('change', this.selectedEftAgreements)
        this.$forceUpdate()
      },
      getCheckBoxValue (props) {
        if ((this.filteredMember !== '') && (props.row.check === false)) {
          return false
        }
        return this.selectedEftAgreements.indexOf(props.row.agreementId) > -1
      }
    },
    computed: {
      eftAgreements: {
        get: function () {
          if (!this.agreementData.firstName) {
            return []
          }
          let masterAgreement = _.map(this.agreementData.agreementEFTs, (agreement) => {
            const agreementData = _.cloneDeep(agreement)
            agreementData.memberName = StringUtils.initCaps(this.agreementData.firstName + ' ' + this.agreementData.lastName)
            agreementData.mainUser = true
            agreementData.autoBilled = 'x-' + this.paymentInfo.cardNumber
            agreementData.accountType = this.paymentInfo.cardType
            if (this.paymentInfo.cardExpirationDate) {
              agreementData.cardExpirationDate = moment(this.paymentInfo.cardExpirationDate, 'MM/YYYY').endOf('month')
              agreementData.cardExpirationDateText = agreementData.cardExpirationDate.format('MM/YYYY')
              agreementData.cardExpirationDateValue = agreementData.cardExpirationDate.valueOf()
            }
            agreementData.selected = true
            return agreementData
          })
          let faoAgreements = _.map(this.agreementData.memberFaos, (owner) => {
            return _.map(owner.agreementEFTs, (agreement) => {
              const agreementData = _.cloneDeep(agreement)
              agreementData.memberName = StringUtils.initCaps(owner.firstName + ' ' + owner.lastName)
              agreementData.mainUser = false
              agreementData.autoBilled = 'x-' + this.paymentInfo.cardNumber
              agreementData.accountType = this.paymentInfo.cardType
              if (this.paymentInfo.cardExpirationDate) {
                agreementData.cardExpirationDate = moment(this.paymentInfo.cardExpirationDate, 'MM/YYYY').endOf('month')
                agreementData.cardExpirationDateText = agreementData.cardExpirationDate.format('MM/YYYY')
                agreementData.cardExpirationDateValue = agreementData.cardExpirationDate.valueOf()
              }
              agreementData.selected = true
              return agreementData
            })
          })
          return masterAgreement.concat([].concat.apply([], faoAgreements))
        }
      }
    }
  }
</script>

<style lang="scss">
  @import '~CommonBilling/css/variables';

  .overdue-card {
    color: red;
  }

  #agreements-eft-table {

    table {

      thead {

        display: none;

      }

      tbody {

        tr {

          background-color: #f5f5f5;
          border-bottom: 2px solid white;

          td {
            &:nth-child(2) {
              text-align: left;
            }

            i {
              margin-right: 10px;
            }
          }
        }
      }
    }
  }

  #agreements-eft-table .cc-sprite {
    float: inherit;
    display: inline-block;
    width:48px;
    height:30px;
    background: url(~CommonBilling/assets/cards-sprites-2x.png);
    background-position-y: 30px;
    zoom: 0.6;
    -moz-transform:scale(0.6);
    -moz-transform-origin: 0 0;
  }

  #agreements-eft-table .mc-cc-color{
    background-position-x: 0px;
  }

  #agreements-eft-table .dis-cc-color {
    background-position-x: 48px;
  }

  #agreements-eft-table .amx-cc-color{
    background-position-x: 96px;
  }

  #agreements-eft-table .visa-cc-color {
    background-position-x: 143px;
  }

</style>



// WEBPACK FOOTER //
// node_modules/MakeAPayment/update_agreements_eft/AgreementsEFTTable.vue